export default class componentsStrings {
    static copyright_copyright = "Copyright (c) $$date$$ AEYE Health Inc.";

    static textfiled_placeholder_username = "Username";
    static textfiled_placeholder_password = "Password";
    static textfiled_placeholder_createpassword = "Create Password";
    static textfiled_placeholder_email = "Email";

    static textfiled_us_restrict = "";

    static hideshowicon_hidepassword = "Hide password";
    static hideshowicon_showpassword = "Show password";

    static link_forgotpwd = "Forgot your password?";
    static link_forgotpwd_new = "Forgot password?";

    static label_image_quality = "Sufficient Image Quality";
    static label_image_iiq = "Insufficient Image Quality";

    static button_upload = "Upload"
    static button_login = "Login";
    static button_forget = "Forget";
    static button_cancel = "Cancel";
    static button_confirm = "Confirm";
    static button_save = "Save";
    static button_close = "Close";
    static button_recover = "Recover";
    static button_register = "Register";
    static button_forgot = "Register";
    static button_back = "Back";
    static button_settings = "Settings";
    static button_users = "Users";
    static button_cameras = "Cameras";
    static button_reports = "Reports";
    static button_logout = "Logout";
    static button_all = "All";
    static button_addnew = "New Exam";
    static button_research = "Research";
    static button_addnewexam = "Add New Exam";
    static button_archive = "Archive";
    static button_unarchive = "Restore";
    static button_grade = "Grade";
    static button_download = "Download";
    static button_send = "Send";
    static button_print = "Print";
    static button_help = "Help";
    static button_yes = "Yes";
    static button_no = "No";
    static button_enter = "Enter";
    static button_next = "Next";
    static button_donediag = "Record Diagnosis";
    static button_notanalyze = "Not Analyzed";
    static button_ok = "OK";
    static button_epic_exams = "View Epic Exams";
    static button_abort = "Abort";
    static button_add = "Add";
    static button_update = "Update";
    static button_create = "Create";
    static button_schedule = "Schedule";
    static button_execute = "Execute";
    static button_delete = "Delete";
    static button_run = "Run";
    static button_edit = "Edit";
    static button_archived = "Archive";
    static button_unarchived = "Unarchived";
    static button_invite = "Invite";
    static button_new = "New";
    static button_select_camera = "Select Camera"
    static button_submit = "Submit"
    static button_reset = "Reset"
    static button_exit = "Exit"
    static button_about = "About";

    // Display when the forgot password email is in process of sending
    static messagetitle_forgotmsg_sending = "Forgot password";
    static messagebody_forgotmsg_sending = "Password recovery message was sent to $$email$$";

    // Display after the email was sent
    static messagetitle_forgotmsg_sent = "Forgot password";
    static messagebody_forgotmsg_sent = "Password recovery message was sent to $$email$$. Please click on the link in the message to complete the process";
    static messagebody_forgotmsg_request = "REQUEST A RESET LINK";
    static messagebody_forgotmsg_username_placeholder = "Enter your username";
    static messagebody_forgotmsg_email_placeholder = "Enter your e-mail";

    // Display when the recover is in process
    static messagetitle_recovermsg_processing = "Recover password";
    static messagebody_recovermsg_processing = "Password recovery in progress. Please wait.";

    // Display after the email was sent
    static messagetitle_recovermsg_processed = "Recover password";
    static messagebody_recovermsg_processed = "Password recovery completed. Please try to login.";

    static table_col_patient = "Patient";
    static table_col_report = "Report";
    static table_col_id = "ID#";
    static table_col_examid = "Exam ID";
    static table_col_clinicname = "Clinic Name";
    static table_col_uploadedtime = "Uploaded on";
    static table_col_diagbytime = "Diagnosed by / time";
    static table_col_patientdiagnosis = "Patient diagnosis";
    static table_paging_noentries = "No entries found";
    static table_paging_show = "Show $$numberofrows$$ out of $$maxnumberofitems$$";
    static table_col_doctordiagnosis = "Patient diagnosis";
    static table_col_patientdiagnosis_byai = "(by A.I.)";
    static table_col_patientdiagnosis_bydoc = "(by Doctor)";

    static table_col_doctordiagnosis_data = "More diagnostic info from a doctor";
    // Display when diagnosis is sent
    static patientview_successsendemail_body = "Email to $$mailto$$ successfully sent";
    static patientview_failedsendemail_body = "Failed to send email";
    static patientview_failedtosendemail_body = "Failed to send email to $$mailto$$";
    static patientview_sendemail_title = "Send report to email";
    static patientview_sendemail_body = "Your diagnosis is being sent. Please wait."
    static patientview_download_title = "Download";
    static patientview_downloading_body = "Your diagnosis is downloading. Please wait.";
    static patientview_iiq = "Sufficient Image Quality";
    static patientview_isq = "Insufficient Image Quality";
    static patientview_uploadedby = "Uploaded by"
    static patientview_diagby = "Diagnosed by"
    static patientview_notdiagyet = "Not diagnosed yet"
    static patientview_patient = "Exam ID"

    static uploadpatient_patientname = "Patient Name";
    static uploadpatient_fullname = "Full Name";
    static uploadpatient_mrn = "MRN";
    static uploadpatient_examid = "Exam ID";
    static uploadpatient_oprname = "Operator Name";
    static uploadpatient_id = "ID";
    static uploadpatient_dateofbirth = "DOB";
    static uploadpatient_gender = "Gender";
    static uploadpatient_gender_male = "Male";
    static uploadpatient_gender_female = "Female";
    static uploadpatient_gender_other = "Other";
    static uploadpatient_cameras = "Cameras";
    static uploadpatient_righteye = "Right Eye";
    static uploadpatient_lefteye = "Left Eye";
    static uploadpatient_browse = "Browse";
    static uploadpatient_browse_for = "for an image to upload";
    static uploadpatient_select_to = "Select to upload an image";
    static uploadpatient_reset = "Reset";
    static uploadpatient_cancelandclose = "Cancel & Close";
    static uploadpatient_saveandclose = "Save & Close";
    static uploadpatient_submitexam = "Submit Exam";
    static uploadpatient_retryexam = "Retry Exam";
    static uploadpatient_submitaccept = "Record Result";
    static uploadpatient_waitforimage = "Wait For Image";
    static uploadpatient_pendingimagecapture = "Pending Image Capture"

    static aeyedetailstable_iiq = "Insufficient Image Quality";
    static aeyedetailstable_noiiq = "Sufficient Image Quality";
    static aeyedetailstable_dr = "Diabetic Retinopathy";
    static aeyedetailstable_glaucoma = "Glaucoma";
    static aeyedetailstable_arm = "Age Related Macular Degeneration";
    static aeyedetailstable_gaarm = "AMD - Geographic Atrophy Prediction (5 Year)";
    static aeyedetailstable_hr = "Blood Pressure";
    static aeyedetailstable_hrSystolic = "Hypertension (Systolic)";
    static aeyedetailstable_hrDiastolic = "Hypertension (Diastolic)";
    static aeyedetailstable_p = "Papilledema";
    static aeyedetailstable_rvo = "Retinal Vein Occlusion";
    static aeyedetailstable_smoking = "Smoking";
    static aeyedetailstable_iop = "Intraocular Pressure";
    static aeyedetailstable_dementia_fii = "Cognitive Assessment - Fluid Intelligence";
    static aeyedetailstable_dementia_pmi = "Cognitive Assessment - Prospective Memory";
    static aeyedetailstable_dementia_risk = "Cognitive Assessment - Dementia 5-Year Risk";
    static aeyedetailstable_dme = "Diabetic Macular Edema";
    static aeyedetailstable_lipidTG = "Triglycerides";
    static aeyedetailstable_lipidLDL = "Cholesterol (LDL)";
    static aeyedetailstable_cataract = "Cataract";
    static aeyedetailstable_drp = "DR Prediction (3 Year)";
    static aeyedetailstable_diabetes = "HbA1c/Diabetes Risk";
    static aeyedetailstable_dementia = "Dementia Risk";
    static aeyedetailstable_cardiovascular = "Cardiovascular Risk";
    static aeyedetailstable_laser = "Laser";
    static aeyedetailstable_other = "Other";
    static aeyedetailstable_comments = "Comments";
    static aeyedetailstable_left_column = "Left Eye";
    static aeyedetailstable_right_column = "Right Eye";
    static aeyedetailstable_failedtodiagnose = "Failed to diagnose";
    static aeyedetailstable_notanalyzed = "Not Analyzed";
    static aeyedetailstable_notapplicable = "Not Applicable";
    static aeyedetailstable_drsuspiciousfinding = "Positive for more-than-mild Diabetic Retinopathy";
    static aeyedetailstable_suspiciousfinding = "Suspicious Findings";
    static aeyedetailstable_nopathologicalfinding = "No Pathological Findings";
    static aeyedetailstable_mildfinding = "Mild Findings";
    static aeyedetailstable_mediumfinding = "Medium Findings";
    static aeyedetailstable_htnborderlinefinding = "Borderline";
    static aeyedetailstable_htninconclusivefinding = "Inconclusive Findings";
    static aeyedetailstable_drprediction = "Risk Group: {0}, Risk Level: {1}"
    static aeyedetailstable_glaucoma_nodiscfound = "Disc not visible";
    static aeyedetailstable_erm = "Epiretinal Membrane";

    static aeyedetailstable_ermPositive = "Positive";
    static aeyedetailstable_ernNegative = "Negative";

    static aeyedetailstable_diabetes_negativefinding = "Negative, No Diabetes / HbA1c < 6.5%"
    static aeyedetailstable_diabetes_mildfinding = "Low Diabetes Risk / Pre-Diabetic / Borderline"
    static aeyedetailstable_diabetes_mediumfinding = "Medium Diabetes Risk / Marginal Diabetes"
    static aeyedetailstable_diabetes_positivefinding = "Positive, Diabetes"

    static aeyedetailstable_smoking_0 = "Non Smoker";
    static aeyedetailstable_smoking_1 = "Likely Non Smoker";
    static aeyedetailstable_smoking_2 = "Light / Pollution Only";
    static aeyedetailstable_smoking_3 = "Likely Smoker";
    static aeyedetailstable_smoking_4 = "Smoker";

    static aeyedetailstable_myopia_0 = "Health"
    static aeyedetailstable_myopia_1 = "Low"
    static aeyedetailstable_myopia_2 = "Moderate"
    static aeyedetailstable_myopia_3 = "Severe"
    
    static aeyedetailstable_mace_0 = "Very high"
    static aeyedetailstable_mace_1 = "High"
    static aeyedetailstable_mace_2 = "Medium"
    static aeyedetailstable_mace_3 = "Low"

    static aeyedetailstable_iop_0 = "No Pathological Findings";
    static aeyedetailstable_iop_1 = "Suspicious Findings";
    static aeyedetailstable_iop_11 = "Inconclusive Findings";

    static aeyedetailstable_visionrisk = "Vision Assessment";
    static aeyedetailstable_spherical_equivalent_left = "Spherical Equivalent Left: ";
    static aeyedetailstable_spherical_component_left = "Spherical Component Left: ";
    static aeyedetailstable_cylinder_component_left = "Cylinder Component Left: ";
    static aeyedetailstable_spherical_equivalent_right = "Spherical Equivalent Right: ";
    static aeyedetailstable_spherical_component_right = "Spherical Component Right: ";
    static aeyedetailstable_cylinder_component_right = "Cylinder Component Right: ";

    static aeyedetailstable_myopiarisk = "Myopia";
    static aeyedetailstable_macerisk = "MACE";
    static aeyedetailstable_ckdrisk = "CKD";

    static aeyedetailstable_dementiafii_0 = "No Pathological Findings";
    static aeyedetailstable_dementiafii_1 = "Suspicious Findings";
    static aeyedetailstable_dementiafii_2 = "Inconclusive Findings";
    static aeyedetailstable_dementiapmi_0 = "No Pathological Findings";
    static aeyedetailstable_dementiapmi_1 = "Suspicious Findings";
    static aeyedetailstable_dementiapmi_2 = "Inconclusive Findings";

    static aeyedetailstable_dementiarisk_0 = "Reduced Risk: 0.2X-0.3X";
    static aeyedetailstable_dementiarisk_1 = "Normal Risk";
    static aeyedetailstable_dementiarisk_2 = "Normal Risk";
    static aeyedetailstable_dementiarisk_3 = "Elevated Risk: 2X-5X";
    static aeyedetailstable_dementiarisk_4 = "Highly Elevated Risk: >5X";
    static aeyedetailstable_dementiarisk_5 = "Elevated Risk: 2X-5X";
    static aeyedetailstable_dementiarisk_6 = "Reduced Risk: 0.2X-0.3X";
    static aeyedetailstable_dementiarisk_7 = "Elevated Risk: 2X-5X";
    static aeyedetailstable_dementiarisk_8 = "Normal Risk";

    static aeyedetailstable_lowrisk = "Low risk";
    static aeyedetailstable_mediumrisk = "Mild risk";
    static aeyedetailstable_highrisk = "High risk";

    static aeyedetailstable_age = "Bio-Age";
    static aeyedetailstable_gender = "Gender";
    static aeyedetailstable_field_title = "Detected field: {0} centered";
    static aeyedetailstable_side_title = "Detected eye: ";

    static diagnosetool_righteye = "Right Eye";
    static diagnosetool_lefteye = "Left Eye";
    static diagnosetool_Summaryeye = "Summary";
    static diagnosetool_failtodiag_title = "Failed to diagnose";
    static diagnosetool_failtodiag_body = "Failed to record doctor's diagnosis";

    static addcameratooperator_enterbarcode_label = "The camera you've selected is being used by another session. To assign the camera to this session and disconnect it from the other session, please enter its 13 digit serial number:";
    static addcameratooperator_enterbarcode_caution_label = "Caution"
    static addcameratooperator_enterbarcode_placeholder = "Camera serial number";

    static addnewalgorithem_name_label = "Name";
    static addnewalgorithem_name_placeholder = "Name of the algorithm";
    static addnewalgorithem_description_label = "Description";
    static addnewalgorithem_description_placeholder = "Algorithm description";
    static addnewalgorithem_path_label = "Path";
    static addnewalgorithem_path_placeholder = "Path to the algorithm";

    static addnewcamera_cameraname_label = "Camera Name";
    static addnewcamera_cameraname_placeholder = "Camera name";
    static addnewcamera_sn_label = "SN";
    static addnewcamera_sn_placeholder = "Camera Serial Number";
    static addnewcamera_type_label = "Type";
    static addnewcamera_camerapath_label = "Camera Path";
    static addnewcamera_camerapath_placeholder = "Camera path";
    static addnewcamera_Email_label = "Email";
    static addnewcamera_Email_placeholder = "Default email for results report";
    static addnewcamera_clinic_label = "Clinic";

    static addnewlicense_startdate_label = "Start Date";
    static addnewlicense_startdate_placeholder = "Start Date";
    static addnewlicense_enddate_label = "End Date";
    static addnewlicense_enddate_placeholder = "End Date";
    static addnewlicense_graceperiod_label = "Grace Period";
    static addnewlicense_graceperiod_placeholder = "Grace Period";

    static addnewclinic_username_label = "User name";
    static addnewclinic_username_placeholder = "Enter user name";
    static addnewclinic_fullname_label = "Full name";
    static addnewclinic_fullname_placeholder = "Enter user full name";
    static addnewclinic_email_label = "Email";
    static addnewclinic_email_placeholder = "Enter user email";
    static addnewclinic_timezone_label = "Time zone";
    static addnewclinic_departmentid_label = "Department ID";
    static addnewclinic_departmentid_placeholder = "Department ID";

    static addnewclinic_addnewuser_title = "Add new user";
    static addnewclinic_addnewuser_body = "User name already exists, please try again";
    static addnewclinic_addnewuserfail_title = "Add new user";
    static addnewclinic_addnewuserfail_body = "An error occured while adding new user, please contact the vendor";

    static addnewuser_username_label = "User name";
    static addnewuser_username_placeholder = "Enter user name";
    static addnewuser_fullname_label = "Full name";
    static addnewuser_fullname_placeholder = "Enter user's full name";
    static addnewuser_email_label = "Email";
    static addnewuser_email_placeholder = "Enter user's email";
    static addnewuser_timezone_label = "Time zone";
    static addnewuser_timezone_placeholder = "Select time zone"
    static addnewuser_departmentid_label = "Department ID";
    static addnewuser_departmentid_placeholder = "Enter department ID";
    static addnewuser_enablereinvite_button = "Enable resending an invitation link";
    static addnewuser_usertype_label = "User type";
    static addnewuser_clinics_label = "Clinics";
    static addnewuser_diseases_label = "Diseases";

    static addnewuser_addnewuser_title = "Add new user";
    static addnewuser_addnewuser_body = "User name already exists, please try again";
    static addnewuser_addnewuserfail_title = "Add new user";
    static addnewuser_addnewuserfail_body = "An error occured while adding new user, please contact the vendor";

    static addnewuser_addnewuser_supportdepartment = "Enable departments"
    static addnewuser_addnewuser_supportcameras = "Enable cameras"
    static addnewuser_addnewuser_supportsettings = "Enable settings"
    static addnewuser_addnewuser_supportreports = "Enable reports"
    static addnewuser_addnewuser_sendreport = "Send Report"
    static addnewuser_addnewuser_getdiagnosis = "Get Diagnosis"
    static addnewuser_addnewuser_internalexam = "Enable internal exam"
    static addnewuser_addnewuser_externalexam = "Enable external exam"
    static addnewuser_addnewuser_supportepicexam = "Enable Epic exams"
    static addnewuser_addnewuser_supportnewpatient = "Enable new patient"
    static addnewuser_addnewuser_addnewuser = "Add new user"
    static addnewuser_addnewuser_encryptipnmode = "Encryption mode"
    static addnewuser_enablereinvite_title = "Enable resending an invitaion link";
    static addnewuser_enablereinvite_body = "A new invitation can be sent to the user";

    static addnewuser_usertype_user = "USER";
    static addnewuser_usertype_uploadonly = "Upload only";
    static addnewuser_usertype_doctor = "Doctor";
    static addnewuser_usertype_clinic = "Clinic";
    static addnewuser_usertype_partner = "Partner";
    static addnewuser_usertype_hospital = "Hospital";
    static addnewuser_usertype_research = "Research";
    static addnewuser_usertype_administrator = "Administrator";

    static addnewuser_encryptipnmode_nothing = "Nothing";
    static addnewuser_encryptipnmode_all = "All";
    static addnewuser_encryptipnmode_onlypatientdata = "Only Patient Data";
    static addnewuser_encryptipnmode_diagnosis = "Diagnosis";

    static reportmenubar_alltimes = "All periods";
    static reportmenubar_1month = "1 month";
    static reportmenubar_3month = "3 months";
    static reportmenubar_6month = "6 months";

    static reportmenubar_runreporton_once = "Run report once";
    static reportmenubar_runreporton_check = "Run report on";
    static reportmenubar_emailsendreportto_check = "Enter comma separated email(s) to which to send report";
    static reportmenubar_emailto_placeholder = "Send report to email";
    static reportmenubar_delete_title = "Delete";
    static reportmenubar_delete_body = "Are you sure you want to delete the report?";
    static reportmenubar_selectreport_title = "Select report";
    static reportmenubar_selectdate_label = "Select date";
    static reportmenubar_selectperiod_label = "Select period"
    static reportmenubar_gender_title = "Gender"
    static reportmenubar_gender_all = "All"
    static reportmenubar_gender_none = "None"
    static reportmenubar_gender_male = "Male"
    static reportmenubar_gender_female = "Female"
    static reportmenubar_gender_other = "Other"
    static reportmenubar_executereport_title = "Report";
    static reportmenubar_executereport_body = "Executing report, please wait...";

    static reportmenubar_reportname_title = "Report name";
    static reportmenubar_reportname_placeholder = "Enter report name";
    static reportmenubar_reportdesc_title = "Report description"
    static reportmenubar_reportdesc_placeholder = "Enter description"
    static reportmenubar_reportSummary_title = "Summary report"
    static reportmenubar_reportsubject_title = "Subject";
    static reportmenubar_reportsubject_placeholder = "Enter subject";

    static aeyeusersettingsadv_msgverid_label = "Message Version ID"
    static aeyeusersettingsadv_msgverid_placeholder = "Enter Message Version ID"
    static aeyeusersettingsadv_assauth_label = "Assigning Authority"
    static aeyeusersettingsadv_assauth_placeholder = "Enter Assigning Authority"
    static aeyeusersettingsadv_leyeide_label = "Left eye identifier"
    static aeyeusersettingsadv_leyeide_placeholder = "Enter left eye identifier"
    static aeyeusersettingsadv_reyeide_label = "Right eye identifier"
    static aeyeusersettingsadv_reyeide_placeholder = "Enter right eye identifier"
    static aeyeusersettingsadv_leyetext_label = "Left eye text"
    static aeyeusersettingsadv_leyetext_placeholder = "Enter left eye text"
    static aeyeusersettingsadv_reyetext_label = "Right eye text"
    static aeyeusersettingsadv_reyetext_placeholder = "Enter right eye text"
    static aeyeusersettingsadv_leyecodesys_label = "Left eye coding system"
    static aeyeusersettingsadv_leyecodesys_placeholder = "Enter left eye coding system"
    static aeyeusersettingsadv_reyecodesys_label = "Right eye coding system"
    static aeyeusersettingsadv_reyecodesys_placeholder = "Enter right eye coding system"

    static aeyeusersettingsgeneral_cameraroot_label = "Camera Root Folder"
    static aeyeusersettingsgeneral_cameraroot_placeholder = "Enter the root folder where all camera images are saved"
    static aeyeusersettingsgeneral_avenueroot_label = "Avenue Root Folder"
    static aeyeusersettingsgeneral_avenueroot_placeholder = "Enter the avenue root folder"
    static aeyeusersettingsgeneral_avenueregfile_label = "Avenue Registered Camera File"
    static aeyeusersettingsgeneral_avenueregfile_placeholder = "Enter the full path file name for the avenue-registered cameras"

    static settingsform_newuser_navlink = "New User"
    static settingsform_users_navlink = "Users"
    static settingsform_systemuser_navlink = "System User"
    static settingsform_algo_navlink = "Algorithms"
    static settingsform_cameras_navlink = "Cameras"

    static settingsformnewuser_email_label = "Email"
    static settingsformnewuser_email_placeholder = "Email"
    static settingsformnewuser_username_label = "Username"
    static settingsformnewuser_username_placeholder = "Username"
    static settingsformnewuser_password_label = "Password"
    static settingsformnewuser_password_placeholder = "Password"
    static settingsformnewuser_fullname_label = "Full name"
    static settingsformnewuser_fullname_placeholder = "Full name"
    static settingsformnewuser_usertype_label = "User type"
    static settingsformnewuser_usertype_placeholder = "User type"

    static aeyealgos_search_label = "Search:";
    static aeyealgos_name_label = "Name";
    static aeyealgos_description_label = "Description";
    static aeyealgos_path_label = "Path";

    static aeyeallcameras_search_label = "Search:";
    static aeyeallcameras_sn_label = "SN";
    static aeyeallcameras_type_label = "Type";
    static aeyeallcameras_clinicname_label = "Clinic name";
    static aeyeallcameras_email_label = "email";

    static aeyecliniccamera_search_label = "Search:";
    static aeyecliniccamera_name_label = "Name";
    static aeyecliniccamera_sn_label = "SN";
    static aeyecliniccamera_type_label = "Type";
    static aeyecliniccamera_email_label = "email";

    static aeyeclinics_search_label = "Search:";
    static aeyeclinics_username_th = "User Name";
    static aeyeclinics_fullname_th = "Full Name";
    static aeyeclinics_timezone_th = "Time zone";
    static aeyeclinics_type_th = "Type";
    static aeyeclinics_email_th = "Email";
    static aeyeclinics_license_th = "License";
    static aeyeclinics_emailresults_th = "Email results";
    static aeyeclinics_lastlogin_th = "Last login";
    static aeyeclinics_camera_th = "Camera";
    static aeyeclinics_algorithem_th = "Algorithem";
    static aeyeclinics_clinics_th = "Clinics";
    static aeyeclinics_deleteuser_title = "Delete a user";
    static aeyeclinics_deleteuser_body = "Are you sure you want to delete this user?";

    static aeyeclinics_usertypedesc_clinic = "Clinic";
    static aeyeclinics_usertypedesc_admin = "Administrator";
    static aeyeclinics_usertypedesc_uploadonly = "Upload Only";
    static aeyeclinics_usertypedesc_doconly = "Doctor Only";
    static aeyeclinics_usertypedesc_researcher = "Researcher";
    static aeyeclinics_usertypedesc_partner = "Partner";
    static aeyeclinics_usertypedesc_hospital = "Hospital";

    static aeyedetailstable_condition_th = "Condition";
    static aeyedetailstable_patientresult_th = "Patient Result";
    static aeyedetailstable_commencts_th = "Comments";

    static aeyeepicexams_search_label = "Search:";
    static aeyeepicexams_exapid_th = "Exam ID";
    static aeyeepicexams_state_th = "State";
    static aeyeepicexams_operatorname_th = "Operator Name";
    static aeyeepicexams_creationdate_th = "Creation Date";
    static aeyeepicexams_departmentid_th = "Department ID";
    static aeyeepicexams_disconnectoperator_title = "Disconnect operator from exam";
    static aeyeepicexams_disconnectoperator_body = "Are you sure you want to disconnect the operator from the exam?"

    static aeyeepicexams_state_new = "New exam";
    static aeyeepicexams_state_waitforeye = "Wait for an image";
    static aeyeepicexams_state_idle = "Idle";
    static aeyeepicexams_state_end = "Ended";
    static aeyeepicexams_state_expired = "Expired";
    static aeyeepicexams_state_submit = "Submitted";
    static aeyeepicexams_state_startmq = "Start processing images";
    static aeyeepicexams_state_failed = "Failed";
    static aeyeepicexams_state_canceled = "Canceled";
    static aeyeepicexams_state_dismiss = "Dismiss";
    static aeyeepicexams_state_aborted = "Aborted";
    static aeyeepicexams_state_mqfinished = "Finish processing images";
    static aeyeepicexams_state_unknown = "Unknown";
    static aeyeepicexams_state_inprogress = "In progress";
    static aeyeepicexams_state_critical = "Critical";

    static aeyereporttable_search_label = "Search:";
    static aeyereporttable_patient_th = "Patient";
    static aeyereporttable_date_th = "Date";
    static aeyereporttable_time_th = "Time";
    static aeyereporttable_patientid_th = "Patient ID";
    static aeyereporttable_clinicname_th = "Clinic Name";
    static aeyereporttable_clinicfullname_th = "Clinic Full Name";
    static aeyereporttable_clinicemail_th = "Clinic Email";
    static aeyereporttable_status_th = "Status";
    static aeyereporttable_diagnosedate_th = "Diagnosis Date";
    static aeyereporttable_diagnosetime_th = "Diagnosis Time";
    static aeyereporttable_diagnoseby_th = "Diagnose By";
    static aeyereporttable_reye_th = "Right Eye";
    static aeyereporttable_leye_th = "Left Eye";
    static aeyereporttable_desis_unknown = "Unknown";
    static aeyereporttable_desis_nothing = "No Pathological Findings";
    static aeyereporttable_desis_dr = "Suspicious Finding - Diabetic Retinopathy";
    static aeyereporttable_desis_iiq = "Insufficient Image Quality";
    static aeyereporttable_desis_missing = "Missing Image";
    static aeyereporttable_desisstatus_diagnosed = "Diagnosed";
    static aeyereporttable_desisstatus_pending = "Pending";
    static aeyereporttable_diagnosedby_algorithem = "Algorithm";

    static aeyeusers_search_label = "Search:";
    static aeyeusers_username_th = "User name";
    static aeyeusers_fullname_th = "Full name";
    static aeyeusers_license_th = "License";
    static aeyeusers_type_th = "Type";
    static aeyeusers_timezone_th = "Time zone";
    static aeyeusers_email_th = "Email";
    static aeyeusers_emailresults_th = "Email results";
    static aeyeusers_lastlogin_th = "Last login";
    static aeyeusers_camera_th = "Camera";
    static aeyeusers_algos_th = "Algorithm";
    static aeyeusers_clinics_th = "Clinics";
    static aeyeusers_usertypedesc_clinic = "Clinic";
    static aeyeusers_usertypedesc_admin = "Administrator";
    static aeyeusers_usertypedesc_uploadonly = "Upload Only";
    static aeyeusers_usertypedesc_doconly = "Doctor Only";
    static aeyeusers_usertypedesc_researcher = "Researcher";
    static aeyeusers_usertypedesc_partner = "Partner";
    static aeyeusers_usertypedesc_hospital = "Hospital";
    static aeyeusers_deleteuser_title = "Delete User";
    static aeyeusers_deleteuser_body = "Are you sure you want to delete this user?";
    static aeyeusers_deleteuserwait_body = "Deleting user, please wait...";

    static uploadcsvimages_uploadnumberof = "Uploading image {0} of {1}";
    static uploadcsvimages_failtoupload_title = "Failed to upload";

    static uploadmultiimages_uploadnumberof = "Uploading image {0} of {1}";
    static uploadmultiimages_failtoupload_title = "Upload";
    static uploadmultiimages_failtoupload_body = "An error occured while uploading images, please contact the vendor";

    static uploadresearchform_uploadmulti_nav = "Upload multiple images";
    static uploadresearchform_uploadcsv_nav = "Upload images with CSV file";

    static uploadresultspatient_desis_diag = "Diagnosis: ";
    static uploadresultspatient_desis_fatal = "Fatal Error";
    static uploadresultspatient_desis_dr = "More-than-mild Diabetic Retinopathy detected: refer to an eyecare professional";
    static uploadresultspatient_desis_nodr = "Negative for more-than-mild Diabetic Retinopathy: retest in 12 months";
    static uploadresultspatient_desis_iiq = "Insufficient Image Quality";
    static uploadresultspatient_desis_missing = "Missing Image";
    static uploadresultspatient_desis_cannot = "Exam processing cannot be completed";
    static uploadresultspatient_fullname_label = "Full Name";
    static uploadresultspatient_gender_label = "Gender";
    static uploadresultspatient_birth_label = "DOB";
    static uploadresultspatient_mrn_label = "MRN";
    static uploadresultspatient_examid_label = "Exam ID: ";
    static uploadresultspatient_testdate_label = "Test Date: ";
    static uploadresultspatient_warning_label = "Warning:";

    static signupform_email_label = "Email address";
    static signupform_email_placeholder = "Enter email";
    static signupform_notsharingemail_label = "We'll never share your email with anyone else.";
    static signupform_reemail_label = "Reenter email address";
    static signupform_reemail_placeholder = "Enter email again";
    static signupform_password_label = "Password";
    static signupform_password_placeholder = "Password";
}
  